export function getOrgChannelName(agencyId: string): string {
  return `org:${agencyId}`;
}

export function getSmartSetupChannelName(agencyId: string): string {
  return `org:${agencyId}:setup`;
}

export function getInboxChannelName(agencyId: string): string {
  return `org:${agencyId}:inbox`;
}

export function getDocumentChannelName(agencyId: string): string {
  return `org:${agencyId}:doc`;
}

export function getMutationChannelName(agencyId: string): string {
  return `org:${agencyId}:mutation`;
}

export function buildAblyCapability(
  agencyId: string | null
): Record<string, string[]> {
  if (!agencyId) {
    return {};
  }

  return {
    [getOrgChannelName(agencyId)]: ["subscribe"],
    [getSmartSetupChannelName(agencyId)]: ["subscribe"],
    [getInboxChannelName(agencyId)]: ["subscribe", "object-subscribe"],
    [getDocumentChannelName(agencyId)]: ["subscribe"],
    [getMutationChannelName(agencyId)]: ["subscribe"],
  };
}
